import(/* webpackMode: "eager" */ "/vercel/path0/src/app/channels/page.tsx");
